import axios from 'axios'
const url = window.checkout_api
const url_api = window.payment_api_pix


export const getByToken = token =>
   axios.get(`${url}mount_order_pay/${token}`)

export const saveUtm = (token, origin, origin_id, utms) =>
   axios.post(`https://api.k8s.sprinta.com.br/inscription/saveutm/${origin}/${origin_id}/${token}`, {utm: utms })

export const addCoupon = (token, coupon) =>
    axios.post(`${url}applyCouponDiscount/${token}`, { code: coupon })

export const getTransactionOrderStatus = tokenlog =>
    axios.get(`${url}getTransactionOrderStatus/${tokenlog}`)

export const getTransactionStatus = tid =>
   axios.get(`${url_api}checkStatusPix/${tid}`)




// WEBPACK FOOTER //
// ./src/App/utils/checkout.js